var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{
    'small': _vm.size === 'small',
    'primary': _vm.size === 'primary',
    'secondary-color': _vm.color === 'secondary',
    'inverted': _vm.color === 'inverted',
  },attrs:{"disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();return _vm.click($event)}}},[_c('div',{staticClass:"button-text"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }